<template>
    <div v-if="isLoading"
        class="h-screen w-full absolute z-[1] flex flex-col gap-y-2 items-center justify-center bg-white">
        <p class="mb-3 w-full text-[22px] font-bold text-center ">Loading</p>
        <div class="loader"></div>
    </div>
</template>

<script lang="ts" setup>
import { ref, defineProps, watch } from 'vue';

const props = defineProps<{
    isLoading: boolean;
}>();


</script>

<style scoped>
#loading-animation {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 80px;
    height: 80px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>